import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  // Token localStorage ya kisi state me save hota hai after login
  const token = localStorage.getItem("adminToken");

  if (!token) {
    // Agar token nahi hai, login page par redirect
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
